import { CustomerEmployeeContactResult } from "..";

export class CustomerEmployeeFullResult {
    public id: number;
    public fullName: string;
    public email: string = '';
    public businessRoleId: number | null;
    public businessRoleName: string;
    public personalPictureFile: Uint8Array | null;
    public personalPictureFileName: string;
    public customerEmployeeContacts: Array<CustomerEmployeeContactResult>;
    public isDeleted: boolean;

    // front-end
    public emailIsInvalid: boolean;
    public fullNameIsInvalid: boolean;
    public businessRoleIdIsInvalid: boolean;
    public customerEmployeeContactIsInvalid: boolean;

    constructor() {
        this.id = 0;
        this.fullName = '';
        this.businessRoleId = null;
        this.businessRoleName = '';
        this.personalPictureFile = null;
        this.personalPictureFileName = '';
        this.customerEmployeeContacts = new Array<CustomerEmployeeContactResult>();
        this.isDeleted = false;
        this.fullNameIsInvalid = false;
        this.emailIsInvalid = false;
        this.businessRoleIdIsInvalid = false;
        this.customerEmployeeContactIsInvalid = false;
    }
}
